
<mat-toolbar>
  <div class="md-toolbar-tools">
    <h1 mat-dialog-title>Itens com códigos de serviço diferentes</h1>
    <span flex></span>
    <div class="posicionar-direita">
      <button (click)="fecharDialog()" class="botao-header" matTooltip="Fechar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>

<div mat-dialog-content>

 
      <p>
  Esta fatura possui itens vinculados a diferentes Códigos de Serviço/Atividade. <br>
  Foram identificados <strong>{{ faturaItensCodigoServicoDto.length }}</strong> códigos distintos.</p>
  
  <p>  Por esse motivo, o faturamento será <strong>desmembrado em {{ faturaItensCodigoServicoDto.length }} faturamentos</strong>, 
  sendo gerada uma nota fiscal/conta a receber para cada grupo de itens que compartilha o mesmo Código de Serviço e Atividade.
</p>

<p>
  A relação detalhada de cada grupo pode ser consultada na tabela abaixo.
</p>

  <mat-table [dataSource]="faturaItensCodigoServicoDto" class=" grouped-table">
    <!-- Coluna: Itens -->
    <ng-container matColumnDef="itens">
      <mat-header-cell *matHeaderCellDef>Serviço/Produto</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <div *ngFor="let faturaItem of item.faturaItems" class="item-container">
          &nbsp;{{faturaItem.codProd}} - {{faturaItem.descricao}}
        </div>
      </mat-cell>
    </ng-container>

    <!-- Coluna: Código de Serviço -->
    <ng-container matColumnDef="codigoServico">
      <mat-header-cell *matHeaderCellDef> Código de Serviço Cadastrado para esse Produto/Serviço</mat-header-cell>
      <mat-cell *matCellDef="let item"> {{ item.codigoServico }} </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
  <p>
  Caso você não deseje separar o faturamento, clique no botão 
  <strong>"Cancelar e ajustar os itens"</strong>. Se o ajuste for necessário apenas para esta fatura, defina, na seção <strong>Dados Fiscais</strong>, 
  qual Código de Serviço/Atividade deverá ser utilizado para a emissão da nota fiscal.
</p>

<p>
  Porém, caso o código esteja incorreto de forma recorrente, será necessário acessar o menu 
  <strong>Produtos e Serviços</strong> localizar o produto/serviço desejado, ir até a aba Fiscal e atualizar o Código de Serviço/Atividade, 
  garantindo que as próximas faturas sejam geradas corretamente.
</p>

</div>

<div mat-dialog-actions>
  <div class="row">
    <div class="col-md-6">
      <button mat-raised-button color="warn" (click)="onNoClick()">Cancelar e ajustar os itens</button>
    </div>
    <div class="col-md-6 text-right">
      <button mat-raised-button color="primary" (click)="onYesClick()">Continuar</button>
  </div>
</div>
</div>
